import {useCookie} from "./useCookie";
import {IsBrowser} from "./isBrowser";

const LOCATION_COOKIE_NAME = "bushbuck_location";
const DETECTED_LOCATION_COOKIE_NAME = "bushbuck_detected_location";
const DEFAULT_LOCATION = process.env.GATSBY_LOCALE_COUNTRY;
const [getCookie] = useCookie();

export function getLocation() {
    const locationCookieValue = getCookie(LOCATION_COOKIE_NAME);
    if (locationCookieValue) {
        return locationCookieValue;
    } else {
        return DEFAULT_LOCATION;
    }
}

export function getDetectedLocation() {
    const locationCookieValue = getCookie(DETECTED_LOCATION_COOKIE_NAME);
    if (locationCookieValue) {
        return locationCookieValue;
    } else {
        return null;
    }
}

export function getLocationUrl(location){
    const locationUrl = new URL(location);
    const currentUrl = IsBrowser()
        ? new URL(window.location.href)
        : null;

    if (!currentUrl) {
        return "";
    }

    currentUrl.host = locationUrl.host;
    currentUrl.searchParams.set('gr', locationUrl.searchParams.get('gr'));
    return currentUrl.toString();
}
